module.exports = __webpack_public_path__ + "static/media/summary_2_for_me.86933c70.png";